import { useLocale } from 'next-intl';
import { useCallback } from 'react';
import { I18nLabel, translate } from '@/utils/i18n';

export function useI18nLabel() {
  const locale = useLocale();
  return useCallback(
    (label: I18nLabel) => {
      return translate(label, locale);
    },
    [locale]
  );
}
